import type { RouteRecordRaw } from 'vue-router'

const defaultLocale: Locale = 'fr'

export interface LocalizedRoute extends Omit<RouteRecordRaw, 'path' | 'children'> {
  path: string
  paths?: Partial<Record<Locale, string>>
  children?: LocalizedRoute[]
}

const generateLocalizedRoutes = (
  routes: LocalizedRoute[],
  locale: Locale,
  parentPath = '',
): RouteRecordRaw[] => {
  return routes.map((route) => {
    const isDefaultLang = locale === defaultLocale
    const localizedPath = route.paths?.[locale] || route.path
    const fullPath = isDefaultLang
      ? `${parentPath}${localizedPath}`
      : `${parentPath === '' ? `/${locale}` : ''}${parentPath}${localizedPath}`

    const localizedRoute = {
      ...route,
      path: fullPath,
      name: `${route.name?.toString()}:${locale}`,
      meta: { locale },
    }

    if (route.children) {
      localizedRoute.children = generateLocalizedRoutes(route.children, locale, fullPath + '/')
    }

    return localizedRoute as RouteRecordRaw
  })
}

export const localizedRoutes = (routes: LocalizedRoute[], locales: Locale[]): RouteRecordRaw[] => {
  return locales.reduce((acc: RouteRecordRaw[], locale: Locale) => {
    const routesForLocale = generateLocalizedRoutes(routes, locale)

    return acc.concat(routesForLocale)
  }, [])
}
